import { createFileRoute } from "@tanstack/react-router";

import { defineHead } from "../-common";

import { LoginPage } from "~/pages/login";
import { Tk } from "~/shared/i18n";

export const Route = createFileRoute("/{-$locale}/_auth/login")({
  head: defineHead({
    titleT: Tk.ACCOUNT_LOGIN,
  }),
  component: LoginPage,
});
